import { CommonModule } from '@angular/common';
import {
    Component,
    OnInit,
    Input,
    OnChanges,
    ViewEncapsulation,
    ChangeDetectorRef,
    ChangeDetectionStrategy
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { DataServiceService } from 'src/app/services/data-service.service';

@Component({
    selector: 'app-chart-embed',
    templateUrl: './chart-embed.component.html',
    styleUrls: ['./chart-embed.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection:ChangeDetectionStrategy.OnPush,
    imports:[CommonModule,SafePipe]
})
export class ChartEmbedComponent implements OnInit, OnChanges {


    @Input() id: number = 0;
    @Input() alphaSymbol ? : string;
    @Input() query: string|undefined;
    @Input() maxWidth: string = "750px"
    @Input() useLazy:boolean=true;

    aspectRatio = "";
    paddingBottom = "";
    iframe:any = {
         src:"",
        title: "IFA Chart"
    }
    url:any;

    prerenderedSizes = [
        // {id:684,width:750,height:1020},
        // {id:685,width:750,height:1300},
        // {id:154,width:750,height:1200},
        // {id:35,width:750,height:900},
        // {id:123,width:750,height:870},
        // {id:96,width:750,height:755},
        // {id:91,width:750,height:820},
        // {id:26,width:750,height:760},
        // {id:78,width:750,height:760},
        // {id:94,width:750,height:760},
        // {id:79,width:750,height:750},
        // {id:80,width:750,height:750},
        // {id:43,width:750,height:830},
        // {id:83,width:750,height:760},
        // {id:85,width:750,height:800},
        // {id:84,width:750,height:560},
    ]

    constructor(private dataservice: DataServiceService, private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer) {
        this.cdr.detach()
    }

    ngOnInit() {
        if(this.id && this.id!=0){
            var resp  = this.prerenderedSizes.find(x=>x.id==this.id);
            if(resp){
                this.aspectRatio = `${ resp.width/resp.height }`;
                this.paddingBottom = `${ (resp.height/resp.width)*100 }%`;
                this.cdr.detectChanges();
                //console.log("PRERENDERED SIZE")
            }
        }
         
    }

    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        //console.log("chart-embed component > ngOnChanges",this.id,changes)
        // console.log("init chart")
        this.dataservice.getChart(this.id).subscribe(resp => {
            //Chart may not have loaded, or no fully approved version was found.    
            this.iframe.title = resp.title + " | IFA Chart";
            if (this.id != 0) {
        
                // console.log(`{id:${this.id},width:${resp.width},height:${resp.height}}`)
                    this.aspectRatio = `${ resp.width/resp.height }`
                    this.paddingBottom = `${ (resp.height/resp.width)*100 }%`
                    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(`https://data.ifa.com/content/charts/${resp.id_other}/${resp.id}/package/index.html`);  
                    this.iframe.src = `https://data.ifa.com/content/charts/${resp.id_other}/${resp.id}/package/index.html`;
                    if (this.alphaSymbol !== undefined) {
                        this.iframe.src = `${this.iframe.src}?param1=${this.alphaSymbol}`
                    }
                    else if(this.query !== undefined){
                        this.iframe.src = `${this.iframe.src}${this.query}`
                    }
                    this.cdr.detectChanges();
                    
                
            }
        })
    }

}